class ValidationUtil {
  isRequired(field) {
    return field !== undefined;
  }

  isUsername(field) {
    var pattern = new RegExp(/^(?!\s)[A-Za-z0-9\s]+$/);
    return pattern.test(field);
  }

  isCharacter(field) {
    var pattern = new RegExp(/^[a-zA-Z,\s]+$/);
    return pattern.test(field);
  }
  isInstitutename(field) {
    var pattern = new RegExp(/^[a-zA-Z\s\-\(\),&,",']+$/);
    return pattern.test(field);
  }
  isFullName(field) {
    var pattern = new RegExp(/^[a-zA-Z ]+$/);
    return pattern.test(field);
  }
  isName(field) {
    var pattern = new RegExp(/^[a-zA-Z]+$/);
    return pattern.test(field);
  }

  isURL(field) {
    var pattern = new RegExp(
      /([\w+]+\:\/\/)?([\w\d-]+\.)*[\w-]+[\.\:]\w+([\/\?\=\&\#\.]?[\w-]+)*\/?/gm
    );
    return pattern.test(field);
  }
  blockScript(field) {
    var pattern = new RegExp(/<|>/g);
    return pattern.test(field);
  }

  isEmail(field) {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    return pattern.test(field);
  }

  isNumber(field) {
    // var pattern = new RegExp(/^(?:1[1][0-9]|120|1[7-9]|[2-9][0-9])$/)
    // var pattern = new RegExp(/^(0?[1-9]|[1-9][0-9]|[1][1-9][1-9]|140|_, )$/);
    var pattern = new RegExp(/^(0?[1-9][0-9]|[1][1-9][1-9]|140|_, )$/);
    return pattern.test(field);
  }
  isNumberText(field) {
    // var pattern = new RegExp(/^(?:1[1][0-9]|120|1[7-9]|[2-9][0-9])$/)
    // var pattern = new RegExp(/^(0?[1-9]|[1-9][0-9]|[1][1-9][1-9]|140|_, )$/);
    var pattern = new RegExp(/^[0-9]+$/);
    return pattern.test(field);
  }
  isContactNumber(field) {
    var pattern = new RegExp(
      /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    );
    return pattern.test(field);
  }
  isMobileNumber(field) {
    var pattern = new RegExp(/^\+\d{1,9}\(\d{3}\)\d{3}\d{4}$/);
    return pattern.test(field);
  }
  isIndianMobileNumber(field) {
    var pattern = new RegExp(/^(6|7|8|9)\d{9}$/);
    return pattern.test(field);
  }

  numberTest(field) {
    var pattern = new RegExp(/^[0-9]{10}$/);
    return pattern.test(field);
  }
  validContactNumberNoZero(field) {
    var pattern = new RegExp(/^(?!0)[0-9]{10}$/);
    return pattern.test(field);
  }

  validDescription(field) {
    var pattern = new RegExp(/^[a-zA-Z0-9.\-,:,",&,' ]{1,500}$/);
    return pattern.test(field);
  }
  maxCharacter(field) {
    var pattern = new RegExp(/^(.{0,500})$/);
    return pattern.test(field);
  }
  isValidEmail(field) {
    var pattern = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
    return pattern.test(field);
  }

  validSubject(field) {
    var pattern = new RegExp(/^[a-zA-Z:?!,_]{1,100}$/);
    return pattern.test(field);
  }

  Characters(field) {
    var pattern = new RegExp(/^([a-zA-Z-]+\s)*[a-zA-Z]+|null$/);
    return pattern.test(field);
  }
  allowedCharacters(field) {
    var pattern = new RegExp(/^[a-zA-Z,." /\\]+$/);
    return pattern.test(field);
  }
  CharactersNull(field) {
    // var pattern = new RegExp(/^[a-zA-Z.\-,/',",&,@,;,:,?,:,!,_,*,\s,]*[0-9]*$|^\w$|[\r\n]/);
    var pattern = new RegExp(/^[a-zA-Z0-9.,'&@"-/;\:?!_*\s]+|[\r\n]+$/);
    return pattern.test(field);
  }
  allowSpecialsCharacters(field) {
    // var pattern = new RegExp(/^[a-zA-Z0-9,.!@()" -\s\n&?:\/\\;. ]+$/);
    var pattern = new RegExp(/^[a-zA-Z0-9,.!@()" -\s&?:\/\\;.\n]+$/);
    return pattern.test(field);
  }
  passwordCharacters(field) {
    var pattern = new RegExp(/^.{5,}$/);
    return pattern.test(field);
  }
  isAge(field) {
    var pattern = new RegExp(/^(?:1[0-9]\d|[1-9]\d|\d)$/);
    return pattern.test(field);
  }
  isCorrectAge(field) {
    var pattern = new RegExp(/\b(?:[0-9]|[1-9][0-9]|1[01][0-9]|120)\b/);
    return pattern.test(field);
  }
  isPercentage(field) {
    var pattern = new RegExp(/^[0-9]{2}$/);
    return pattern.test(field);
  }
  isPercentageNumber(field) {
    var pattern = new RegExp(/\b(?:0|[1-9][0-9]?|100)\b/);
    return pattern.test(field);
  }
  israting(field) {
    var pattern = new RegExp(/^(10|[0-9])$/);
    return pattern.test(field);
  }
  isStrongPassword(field) {
    var pattern = new RegExp(
      // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&#]*$/
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#+]*$/
      // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/
    );
    return pattern.test(field);
  }
  isValidAadharNumber(field) {
    // var pattern = new RegExp(/^\d{12}$/);
    var pattern = new RegExp(/^\d{4} \d{4} \d{4}$/);
    return pattern.test(field);
  }
  isValidPincode(field) {
    var pattern = new RegExp(/^\d{6}$/);
    return pattern.test(field);
  }
  isExperince(field) {
    // var pattern = new RegExp(/\b([0-9]|[1-9][0-9]|99)\b/);
    var pattern = new RegExp(/\b([0-9]|[1-9][0-9]|99)\.?\b/);
    return pattern.test(field);
  }
  isEventName(field) {
    var pattern = new RegExp(/[!@#$%^*+=-><?;]/);
    return pattern.test(field);
  }

  // ==========================================================================
  //                              CONFERENCE Validation
  // ==========================================================================

  isRequiredEmpty(field) {
    // return field !== "" || field !== undefined;

    if (field === null) return false;
    if (field === undefined) return false;
    else if (field === "") return false;
    else return true;
  }

  isLowSecCharacter(field) {
    var pattern = new RegExp(/^[^@<>]+$/);
    return pattern.test(field);
  }

  isCharOrHyphen(field) {
    var pattern = new RegExp(/^[a-zA-Z-]+$/);
    return pattern.test(field);
  }
  isCharOrHyphenMoreSecurity(field) {
    var pattern = new RegExp(/^[a-zA-Z0-9-.,&]+$/);
    return pattern.test(field);
  }

  isFullName(field) {
    var pattern = new RegExp(/^[a-zA-Z ]+$/);
    return pattern.test(field);
  }

  isCharAndNumber(field) {
    var pattern = new RegExp(/^[a-zA-Z0-9 ]+$/);
    return pattern.test(field);
  }

  isHighSecString(field) {
    // var pattern = new RegExp(/^[^@<>!#$%^&*?: ]+$/);
    var pattern = new RegExp(/^[^@<>!#$%^&*?:]+$/);
    return pattern.test(field);
  }
  isRichTextEditorContentEmpty(content) {
    if (!content) return true;
    // Regex to match empty or whitespace-only content inside HTML tags
    const textOnly = content.replace(/<[^>]*>/g, "").trim();

    // Check if there's any actual content left
    return textOnly === "";
  }

}

export default new ValidationUtil();
